var React = require('react');

function In (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"32","rx":"6","fill":"#3077B5","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.87572 9.79107C5.2882 9.79107 4 8.47321 4 6.88214C4 5.29107 5.2882 4 6.87572 4C8.46325 4 9.75145 5.29107 9.75145 6.88214C9.75145 8.47321 8.46325 9.79107 6.87572 9.79107ZM9.36125 28H4.39555V11.9768H9.36125V28ZM22.9915 28H27.9465H27.9519V19.1982C27.9519 14.8911 27.0272 11.575 22.0027 11.575C19.5866 11.575 17.967 12.9036 17.3042 14.1625H17.2347V11.9768H12.4722V28H17.4325V20.0661C17.4325 17.9768 17.8281 15.9571 20.4098 15.9571C22.9541 15.9571 22.9915 18.3411 22.9915 20.2V28Z","fill":"white","key":1})]);
}

In.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = In;

In.default = In;
